import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { AccountDataComponent } from './account-data.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.account-data', {
            url: '/account-data',
            data: {
                authorisationLevel: 0,
                pageTitle: 'Account Data'
            },
            ncyBreadcrumb: {
                label: 'Dati Account',
                parent: 'registration.registration-type'
            },
            'views': {
                'multiContentRegistration': {
                    template: '<account-data flex="100"></account-data>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const AccountDataModule: string = ng
    .module('account-data', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('accountData', AccountDataComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/account-data/account-data.module.ts